import { render, staticRenderFns } from "./TgWalkthrough.vue?vue&type=template&id=03502528&"
import script from "./TgWalkthrough.vue?vue&type=script&lang=js&"
export * from "./TgWalkthrough.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports